<template>
  <label class="border border-dark fs-m font-weight-bold px-1 m-0">
    <slot />
  </label>
</template>

<script>
export default {

}
</script>

<style>

</style>